import $ from "jquery";

const $printBtn = $(".js--print");

if (!typeof window.print) {
  $printBtn.remove();
}

$(".js--print").on("click", function () {
  window.print();
});
